<form *ngIf="formGroup" [formGroup]="formGroup">
  <h4 class="fd-subtitle">Quadro Societário e Beneficiários Finais</h4>

  <p *ngIf="bureauError" class="qsa-error">{{ bureauError }}</p>

  <app-qsa-node class="qsa-tree" *ngIf="qsaRows.length" [nodes]="qsaRows" [host]="this"></app-qsa-node>

  <p *ngIf="bureauLoaded && !bureauError && !qsaRows.length">Nenhum sócio retornado para este CNPJ.</p>

  <fd-button fdSecondary [content]="'cancelar'" (trigger)="back(false)"> </fd-button>
  <fd-button [content]="'avançar'" (trigger)="next()"> </fd-button>
</form>
